<div class="content-scoring">
    <div class="score-container">
        <div class="score-header">
            <span class="status-text">{{ 'listing.contentScoring.header' | translate }}</span>
        </div>

        <app-progress-bar
            [progress]="contentScoringService.scoreResult()?.totalScore || 0"
            mode="temperature"
            [label]="progressText() | translate"
            [showProgressValue]="true"
        ></app-progress-bar>

        <div class="score-title">
            <p class="heading">{{ 'listing.contentScoring.title' | translate }}</p>
        </div>
    </div>

    <div class="items-list-container">
        <ul class="items-list">
            @for (item of items(); track item.label; let idx = $index) {
                <li class="item-row" [ngClass]="item.isComplete ? 'complete' : 'incomplete'">
                    @if (item.isComplete) {
                        <i class="fa-regular fa-circle-check icon completion-mark"></i>
                    } @else {
                        <i class="fa-regular fa-circle-xmark icon completion-mark"></i>
                    }
                    <div class="item-text">
                        @let hasSubItems = item.subItems?.length;
                        <div class="item-label-container" [ngClass]="hasSubItems ? 'has-sub-items' : ''">
                            <div
                                class="item-label"
                                [ngClass]="!hasSubItems ? 'is-clickable' : ''"
                                (click)="!hasSubItems ? navigateAndScrollToField(item) : null"
                            >
                                <span class="item-label-text">{{ item.label | translate }}</span>
                            </div>
                            @if (hasSubItems) {
                                <details class="sub-items-expand-container">
                                    <summary class="item-note">
                                        @if (item.note) {
                                            {{
                                                item.note | translate: { totalCount: item.totalCount, completedCount: item.completedCount }
                                            }}
                                        }
                                    </summary>
                                    <ul class="sub-items-list">
                                        @for (subItem of item.subItems; track subItem.itemName; let subIdx = $index) {
                                            <li class="sub-item-container">
                                                <div class="sub-item" [ngClass]="subItem.isCompleted ? 'complete' : 'incomplete'">
                                                    @if (subItem.isCompleted) {
                                                        <i class="fa-regular fa-check icon completion-mark"></i>
                                                    } @else {
                                                        <i class="fa-regular fa-xmark icon completion-mark"></i>
                                                    }
                                                    <span
                                                        class="sub-item-name is-clickable"
                                                        (click)="navigateAndScrollToField(item, subItem)"
                                                        >{{ subItem.itemName }}</span
                                                    >
                                                </div>

                                                @if (!subItem.isCompleted) {
                                                    <button
                                                        class="button link primary small"
                                                        title="Add missing information"
                                                        (click)="navigateAndScrollToField(item, subItem)"
                                                    >
                                                        {{ 'listing.contentScoring.addMissingInformation' | translate }}
                                                    </button>
                                                }
                                            </li>
                                        }
                                    </ul>
                                </details>
                            } @else if (item.note) {
                                <span class="item-note">{{ item.note | translate }}</span>
                            }
                        </div>
                        @if ((!item.isComplete && !item.subItems) || (!item.isComplete && item.subItems?.length === 0)) {
                            <button
                                class="button link primary small"
                                title="{{ 'listing.contentScoring.addMissingInformation' | translate }}"
                                (click)="navigateAndScrollToField(item)"
                            >
                                {{ 'listing.contentScoring.addMissingInformation' | translate }}
                            </button>
                        }
                    </div>
                </li>
            } @empty {
                <li class="no-items">{{ 'listing.contentScoring.noItems' | translate }}</li>
            }
        </ul>
    </div>
    <button class="button secondary" (click)="closeModalInstance(undefined)" [title]="'generalKeywords.close' | translate">
        {{ 'generalKeywords.close' | translate }}
    </button>
</div>
